// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import crest from "../../dmxHelper/assets/wrpfarg-logo.webp";
import crestRing from "./assets/wrpf-anillo.webp";

import styles from "./PhotoFrame.module.scss";

export type PhotoFrameVariant = "medalla" | "recuadro";

interface Props {
  url: string | null;
  name: string;
  variant: PhotoFrameVariant;
  /** Lado de la foto en px del lienzo. Las fotos de hoy son de 250×250: cuanto más cerca, menos se nota. */
  size: number;
}

type FrameStyle = React.CSSProperties & { "--photo-size": string };

const PhotoFrame = ({ url, name, variant, size }: Props) => {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [url]);
  const showPhoto = url !== null && !failed;

  return (
    <div className={styles.frame} data-variant={variant} style={{ "--photo-size": `${size}px` } as FrameStyle}>
      <div className={styles.ring}>
        <div className={styles.window} data-empty={showPhoto ? undefined : "true"}>
          {showPhoto ? (
            <img className={styles.image} src={url} alt={name} onError={() => setFailed(true)} />
          ) : (
            <img className={styles.crest} src={crest} alt="WRPF Argentina" />
          )}
        </div>
      </div>
      {variant === "medalla" ? (
        // El anillo del escudo WRPF es el marco: la foto ocupa el lugar del centro del logo.
        <img className={styles.crestRing} src={crestRing} alt="" aria-hidden="true" />
      ) : (
        <img className={styles.cornerCrest} src={crest} alt="" aria-hidden="true" />
      )}
    </div>
  );
};

export default PhotoFrame;
